export default "__VITE_ASSET__3rpsfHMh__"